<template>
  <div class="wrapper">
    <div v-if="joblist.length == 0" class="nofind">
      <img src="@/assets/no_data.png" style="margin: 20px auto">
      <p>暂时没有发布的职位哦，快去发布吧</p>
    </div>
    <template v-if="!show" >
      <el-card v-for="(item, key) in joblist" :key="key" class="mycard" @click.native="checkDetail(item.id)">
        <p>职位名称：{{item.name}}</p>
        <p>工作经验：{{item.experience}}</p>
        <p>学历要求：{{item.education}}</p>
        <p>职位介绍：{{item.content}}</p>
        <div>
          <el-button class="delbtn" @click="deletejob(item.id)">删除职位</el-button>
          <div size="small" class="clearfix"></div>
        </div>
      </el-card>
    </template>

  </div>
</template>
<script>
import fetch from '../../api/fetch'
import getData from "@/api/getData";
export default {
  data () {
    return {
      joblist: [],
      count: 0,
      show: false
    }
  },
  mounted () {
      console.log(2222)
    this.checkJob()
  },
  watch: {
    count () {
      location.reload()
    }
  },
  methods: {
    checkDetail (id) {
        console.log(id)
      localStorage.setItem('jobId', id)
      this.$router.push({name: 'jobInfo'})
    },
    checkJob () {
        let account = localStorage.getItem('recruit_account')

        if(account){
            getData.get('https://nocoapi.kuailework.com/api/v2/tables/mp4l49rzxw9n1zo/records',{
                where: '(account,eq,' + account + ')'
            }).then(res =>{
                if(res && res.data.list && res.data.list.length > 0){
                    this.joblist = res.data.list
                }
            })
        }else{
            this.$router.push({name: 'index'})
        }
    },
    deletejob (id) {
        console.log(id)
      // fetch.deletejob(id).then(res => {
      //   if (res.status === 200) {
      //     if (res.data.success === true) {
      //       this.count++
      //     }
      //   }
      // }).catch(e => {
      //   console.log(e)
      // })
    }
  }
}
</script>

<style>

.mycard {
  border-left: 5px solid #888;
  margin-bottom: 14px;
  text-align: left;
  padding-bottom: 10px;
}
.myflex {
  float: left;
}
.delbtn {
  float: right;
}
</style>
